import { UAParser } from 'ua-parser-js'

const deviceInfo = async () => {
  const device = {}
  const parserResult = UAParser()

  if (navigator.userAgentData) {
    const uad = await navigator.userAgentData.getHighEntropyValues(['model', 'mobile', 'platform'])

    device.platform = uad.platform
    device.model = uad.model
    device.isMobile = uad.mobile
  }

  if (!device.model) {
    device.platform = parserResult.os.name
    device.model = parserResult.device.model
    device.isMobile = parserResult.device.type === 'mobile'
  }

  device.vendor = parserResult.device.vendor

  return device
}

export { deviceInfo }